import { connect } from 'react-redux';
import { StoreState } from '../../reducers';
import Utils from '../../utils/index';
import DownloadManagerUtils from '../../utils/downloadManager';
import StaticPage from '../../components/StaticPage';
import { GalleryInfosState } from '../Gallery/reducer';
import { DownloadManagerState } from '../DownloadManager/reducer';

const getIframeUrl = (galleryInfos: GalleryInfosState, downloadManager: DownloadManagerState, locale: string, componentId: number): string => {
	const isAvailableOffline = DownloadManagerUtils.isItemDownloaded(downloadManager, componentId);
	const componentUrl = Utils.getComponentUrl(galleryInfos, componentId, isAvailableOffline, locale);
	return componentUrl;
};

const mapStateToProps = (state: StoreState, ownProps) => {
	const { galleryInfos, downloadManager, driveList, selection, i18n: { locale } } = state;
	const { componentId } = ownProps;

	const iframeUrl = getIframeUrl(galleryInfos, downloadManager, locale, componentId);

	return { downloadManager, driveList, selection, iframeUrl };
};

export default connect(mapStateToProps)(StaticPage);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/StaticPage/index.tsx